import React, { ReactNode, useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import ReactPagination from "react-js-pagination"
import { PAGINATION_DEFAULTS, PaginationState } from "../../../../state/listing/generic-listing"
import Icon from "../../../icon/icon.component"
import "./ListingPagination.scss"

interface OwnProps {
    activePage: number
    pageSize: number
    pageSizeMax: number
    totalItemCount: number
    showPageSize?: boolean
    onPaginationChange: (pagination: PaginationState) => void
}

const PAGE_SIZES = [5, 10, 25, 50]

const Pagination = (props: OwnProps) => {
    const [pagination, setPagination] = useState<PaginationState>(PAGINATION_DEFAULTS)

    useEffect(() => {
        setPagination({
            activePage: props.activePage,
            pageSize: props.pageSize,
            pageSizeMax: props.pageSizeMax,
            totalItemCount: props.totalItemCount,
        })
    }, [props.activePage, props.pageSize, props.totalItemCount])

    const handleActivePageChange = (activePage: number) => {
        props.onPaginationChange({
            ...pagination,
            activePage,
        })
    }

    const handlePageSizeChange = (pageSize: number) => {
        props.onPaginationChange({
            ...pagination,
            pageSize,
        })
    }

    const getPaginationsizeDropdown = (pageSize: number): ReactNode => {
        return (
            <a
                key={pageSize}
                className="dropdown-item"
                href="#"
                onClick={() => handlePageSizeChange(pageSize)}
            >
                <FormattedMessage
                    id="common.pagination.per_page_label"
                    defaultMessage="{number} per page"
                    values={{
                        number: pageSize
                    }}
                />
            </a>
        )
    }

    return (
        <div className="Pagination row ui-has-modules py-1 d-flex align-items-center">
            <div className="ui-module mb-0 p-0">
                <ReactPagination
                    hideDisabled
                    activePage={pagination.activePage}
                    itemsCountPerPage={pagination.pageSize}
                    totalItemsCount={pagination.totalItemCount}
                    pageRangeDisplayed={5}
                    onChange={handleActivePageChange}
                    innerClass="pagination mb-0 pagination-text"
                    activeClass="active"
                    linkClass="page-link border-0"
                    itemClass="page-item"
                    prevPageText={"<"}
                    firstPageText={"l<"}
                    lastPageText={">l"}
                    nextPageText={">"}
                />
            </div>
            {props.showPageSize && pagination.totalItemCount > 0 && (
                <div className="ml-2" role="group">
                    <button id="btnGroupDrop1" type="button" className="btn btn-link text-primary btn-sm" data-toggle="dropdown">
                        <FormattedMessage
                            id="common.pagination.per_page_label"
                            defaultMessage="{number} per page"
                            values={{
                                number: pagination.pageSize
                            }}
                        />
                        <Icon value="caret-down" className="ml-1" />
                    </button>
                    <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        {
                            PAGE_SIZES
                                .filter(pageSize => pageSize <= pagination.pageSizeMax)
                                .map(pageSize => (
                                    getPaginationsizeDropdown(pageSize)
                                ))
                        }
                    </div>
                </div>
            )}
        </div>
    )
}

export default Pagination


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-pagination/ListingPagination.tsx